module.exports = __webpack_public_path__ + "static/media/8200.8e67458f.jpg";